<template>
  <v-card v-if="properties != null" flat>
    <div>
      <CImage
        v-if="properties.image != null"
        :url="properties.image"
        :alt="properties.title"
        :contain="image_contained"
        size="100px"
        width="39%"
      />
    </div>
    <div class="card-content">
      <PrimaryTitle :title="properties.title"></PrimaryTitle>
      <v-card-subtitle
        v-if="properties.subtitle"
        class="card-subtitle dark_grey--text"
        >{{ properties.subtitle }}</v-card-subtitle
      >
      <v-card-text v-if="properties.text" class="card-text text--primary">
        <template v-for="(txt, id) in properties.text">
          <CText :text="txt" :key="id" class="mt-3" />
        </template>
      </v-card-text>
      <v-card-text v-if="properties.paragraphe" class="card-text text--primary">
        <template v-for="(txt, id) in properties.paragraphe">
          <CText :text="txt" :key="id" text_type="paragraphe" class="mt-3" />
        </template>
      </v-card-text>
      <div v-if="properties.list">
        <CList
          :list="properties.list"
          :color="this.$vuetify.theme.themes.light.blue_6"
        />
      </div>
    </div>
  </v-card>
</template>

<script>
import CImage from "../SubComponents/Image";
import CList from "../SubComponents/List";
import PrimaryTitle from "../SubComponents/PrimaryTitle";

export default {
  name: "SmallLeftCard",
  components: {
    CImage,
    CList,
    PrimaryTitle
  },
  props: {
    properties: {
      type: Object,
      default: null
    },
    image_contained: {
      type: Boolean,
      default: false
    },
    variant_color: {
      type: Boolean,
      default: false
    }
  },
  methods: {}
};
</script>
